import React from "react";

import { hooks } from "../hooks";
import { theme } from "../constants";
import { setScreen } from "../store/slices/tabSlice";
import { TABS } from "../constants/app_routes";
import { BriefcaseIcon, ProfileIcon, TrendIcon } from "../constants/icons";
import { useQueryCountMyTrades } from "../graphql/apollo/useQuery";
import { Badge } from "@mui/material";

const tabs = [
  {
    id: 1,
    name: TABS.Home,
    icon: TrendIcon,
  },
  {
    id: 2,
    name: TABS.MY_TRADES,
    icon: BriefcaseIcon,
  },
  {
    id: 3,
    name: TABS.PROFILE,
    icon: ProfileIcon,
  },
];

export const BottomTabBar: React.FC = () => {
  const dispatch = hooks.useDispatch();
  const tabScreen = hooks.useAppSelector((state) => state.tabSlice.screen);
  const { countMyTrades } = useQueryCountMyTrades();

  return (
    <footer>
      <ul style={{ background: theme.colors.backgroundColorDark }}>
        {tabs.map((tab) => {
          return (
            <li
              key={tab.id}
              onClick={() => dispatch(setScreen(tab.name))}
              style={{
                cursor: "pointer",
                borderRadius: 3,
              }}
            >
              {tab.name === TABS.MY_TRADES && countMyTrades > 0 && (
                <Badge badgeContent={countMyTrades} color="warning"></Badge>
              )}

              <tab.icon
                size={20}
                color={
                  tabScreen === tab.name
                    ? theme.colors.white
                    : theme.colors.secondaryTextColor
                }
              />
            </li>
          );
        })}
      </ul>
    </footer>
  );
};
